<template>
    <div class="translation-field" v-bind:class="missing?'is-invalid':''">
        <div>
            <label :for="attributes.name" class="label">{{ attributes.verbose_name }}</label>
            <div v-if="attributes.type !== 'wysiwyg'">
                <input class="input" :name="attributes.name" :readonly="readonly" type="url" v-model="val" v-if="attributes.type === 'url'" />
                <input class="input" :name="attributes.name" :readonly="readonly" type="text" v-model="val" :maxlength="maxChars" v-else />
            </div>
            <div v-else>
                <wysiwyg v-model="val" :options="{maxChars: maxChars, readonly: readonly}"></wysiwyg>
            </div>
        </div>
        <a href="" v-if="readonly" class="arrow" @click.stop.prevent="onArrowClicked">
            <span>&#9654;</span>
        </a>
    </div>
</template>

<script>
    import { Wysiwyg } from '../../components';

    export default {
        name: 'translation-field',

        components: {
            Wysiwyg,
        },

        props: {
            value: {
                type: Object,
                required: true,
                default() {
                    return [];
                },
            },
            attributes: {
                type: Object,
                required: true,
            },
            section: {
                type: String,
            },
            lang: {
                type: String,
                required: true,
            },
            readonly: {
                type: Boolean,
                default: false,
            },
            missing: {
                type: Boolean,
                default: false,
            },
        },

        data() {
            return {
                val: '',
                maxCharsMapping: {
                    campsites: 600,
                    extras: 300,
                    persons: 300,
                    seasons: 600,
                    settings: 600,
                },
            };
        },

        created() {
            this.val = this.content;
        },

        computed: {
            content() {
                if(!this.value) {
                    return null;
                }
                return this.value.value;
            },
            maxChars() {
                if(!this.attributes.max_length) {
                    if(this.attributes.type === 'wysiwyg') {
                        if(this.maxCharsMapping[this.section]) {
                            return this.maxCharsMapping[this.section];
                        }
                    }
                    return null;
                }
                return this.attributes.max_length;
            },
        },

        watch: {
            value(newVal) {
                if(newVal.value !== this.val) {
                    this.val = newVal.value;
                }
            },
            val(newVal) {
                if(this.readonly || newVal === undefined || !this.value) {
                    return;
                }
                let trans = Object.assign({}, this.value);
                trans.value = newVal;
                this.$emit('input', trans);
            }
        },

        methods: {
            onArrowClicked() {
                this.$emit('copy-content', this.content);
            },
        },
    };
</script>

<style lang="scss">
    @import './translation-field.scss';
</style>



// WEBPACK FOOTER //
// src/views/components/translations/translation-field.vue